import { SupplierOrigin } from '../../../interfaces/Supplier/SupplierOrigin/SupplierOrigin'

export const getColumnsConfig = () => [
  { key: 'supplierOriginName' as keyof SupplierOrigin, title: 'Origen' },
  { key: 'supplierName' as keyof SupplierOrigin, title: 'Nombre Proveedor' },
  {
    key: 'productControlPercentage' as keyof SupplierOrigin,
    title: 'Porcentaje Control',
    render: (value: string | number | boolean | undefined) => {
      if (typeof value === 'number') {
        return `${value}%`
      }
      return 'N/A'
    }
  },
  {
    key: 'draft' as keyof SupplierOrigin,
    title: 'Draft',
    render: (value: string | number | boolean | undefined) => {
      return value ? 'Sí' : 'No'
    }
  },
  {
    key: 'active' as keyof SupplierOrigin,
    title: 'Activo',
    render: (value: string | number | boolean | undefined) => {
      return value ? 'Sí' : 'No'
    }
  }
]
